<template>
	<section id="Demandas">
		<div class="container">
			<div class="collections">
				<div class="container1">
					<div class="area_title">
						<div class="text">HISTÓRICO DE DEMANDAS</div>
						<div class="search"><input type="text" v-model="search" v-on:keyup.enter="searchDemands" placeholder="Filtre sua demanda"><i class="fas fa-search" @click="searchDemands"></i></div>
					</div>
					<div class="collections_list">
						<DemandItem v-for="lc in filteredDemands" :key="lc.id" :id="lc.id" :name="lc.nome" :requestOn="new Date()" :status="'Em andamento'" />
					</div>
					<div class="collections_actions">
						<button @click="loadMoreDemands">Carregar mais</button>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
import axios from 'axios'
import DemandItem from '@/components/shared/DemandItem'
export default {
	name: 'Demandas',
	data () {
		return {
			skip: 0,
			take: 10,
			filteredDemands: [],
			search: ''
		}
	},
	components: {
		DemandItem
	},
	async created () {
		this.getfilteredDemands()
	},
	methods: {
		getfilteredDemands () {
			// todo: precisa ajustar as rotos da api para últimas coleções cadastradas e curtidas
			const q = (this.search) ? `&q=${this.search}` : ''
			const filteredDemands = axios.get(`/objetos/mais_acessados?take=${this.take}&skip=${this.skip}${q}`)

			Promise.all([filteredDemands]).then(data => {
				this.filteredDemands = this.filteredDemands.concat(data[0].data)
			})
		},
		searchDemands () {
			this.filteredDemands = []
			this.skip = 0
			this.getfilteredDemands()
		},
		loadMoreDemands () {
			this.skip++
			this.getfilteredDemands()
		}
	}
}
</script>

<style lang="scss" scoped>
	#Demandas {
		margin-top: 120px;
		@media all and (max-width: 700px) {
			& {
				margin-top: 0 !important;
			}
		}

		background-size: 30px;
		background-image: url('../../../assets/images/bg.svg'), linear-gradient(180deg, transparent, rgba(255,255,255,0), rgba(27, 40, 56, 1));
		color: #fff;

		.container {
			.top_actions {
				text-align: left;
				padding-top: 30px;

				button {
					width: 170px;
					padding: 10px 14px;
					border: none;
					color: #FFF;
					text-transform: uppercase;
					font-size: 15px;
					letter-spacing: .5px;
					font-family: 'Roboto Condensed', 'Roboto', sans-serif;
					font-weight: bold;
					margin-top: 30px;
					cursor: pointer;

					background: transparent linear-gradient(74deg, #224894 0%, #00F3F3 100%) 0% 0% no-repeat padding-box;
					border-radius: 5px;

				}
			}

			.collections {
				.collections_actions {
					text-align: center;

					button {
						width: 300px;
						padding: 12px 25px;
						border: none;
						border-radius: 5px;
						background-color: #00659D;
						color: #FFF;
						text-transform: uppercase;
						font-size: 16px;
						letter-spacing: .5px;
						font-family: 'Roboto Condensed', 'Roboto', sans-serif;
						font-weight: bold;
						margin-top: 30px;
						cursor: pointer;
					}
				}
			}
			.area_title {
				-webkit-font-smoothing: antialiased;
				margin: 0;
				padding: 0;
				border: 0;
				font: inherit;
				vertical-align: baseline;
				padding-top: 40px;
				margin-bottom: 20px;
				font-family: "Roboto Condensed","Roboto",sans-serif;
				font-size: 22px;
				font-weight: bold;
				color: #fff;
				text-transform: uppercase;
				text-align: left;
				box-sizing: border-box;

				.text {
					-webkit-font-smoothing: antialiased;
					color: #fff;
					text-transform: uppercase;
					text-align: left;
					margin: 0;
					padding: 0;
					border: 0;
					vertical-align: baseline;
					display: inline-block;
					box-sizing: border-box;
				}

				.search {
					float: right;
					clear: both;
					width: 40%;

					input {
						width: 100%;
						margin: 0;
						border: 0;
						padding: 1px 20px;
						border-radius: 10px;
						font-size: 10px;
						line-height: 20px;
						color: #06162b;
						background-color: #f8f9fb;
						box-sizing: border-box;
						-webkit-font-smoothing: antialiased;
						text-align: left;
						vertical-align: baseline;
						display: inline-block;
					}

					i {
							font-size: 12px;
							position: relative;
							z-index: 1;
							left: -25px;
							top: 1px;
							color: #7B7B7B;
							cursor: pointer;
							width: 0;
					}

				}
			}
		}
	}
</style>
